import React from 'react';

export default function StudioLandingFeature({feature}) {
	const style = {
			backgroundColor: feature.bgColor
		,	backgroundImage: `linear-gradient(257.42deg, rgba(${hexToRGB(feature.bgColor).r}, ${hexToRGB(feature.bgColor).g}, ${hexToRGB(feature.bgColor).b}, 0) 19.24%, ${feature.bgColor} 79.8%),
												linear-gradient(90deg, #2C2E35 1px, transparent 1px),
												linear-gradient(180deg, #2C2E35 1px, transparent 1px)`
	}

	return (
		<article className="studio-feature" style={{...style}}>
			<div className="studio-feature__internal">
				<div className="studio-feature__main">
					<h2 className="studio-feature__title">{feature.strTitle}</h2>
					<div className="studio-feature__content" dangerouslySetInnerHTML={{__html: feature.strContent}}/>
					<a href={feature.strCTAURL} className="studio-feature__cta btn btn--white l-border">{feature.strCTAText}<i className={`l-margin-left ${feature.strCTAURL.indexOf('www.bricklink.com') != -1 ? 'fas fa-arrow-right-long' : 'far fa-square-arrow-up-right'}`}/></a>
				</div>
				{feature.dmImageXL ? 
					<div className={`studio-feature__image-container studio-feature__image-container--${feature.strImageAttachment}`}>
						<img className="studio-feature__image studio-feature__image--xl" style={{maxWidth: feature.dmImageXL.n2ImageWidth ? feature.dmImageXL.n2ImageWidth/2 + 'px' : '100%'}} src={feature.dmImageXL.url} alt={`${feature.strTitle} in action`}/>
						<img className="studio-feature__image studio-feature__image--desktop" style={{maxWidth: feature.dmImageDesktop ? feature.dmImageDesktop.n2ImageWidth/2 + 'px' : feature.dmImageXL.n2ImageWidth/2 + 'px'}} src={feature.dmImageDesktop ? feature.dmImageDesktop.url : feature.dmImageXL.url} alt={`${feature.strTitle} in action`}/>
						<img className="studio-feature__image studio-feature__image--medium" style={{maxWidth: feature.dmImageMedium ? feature.dmImageMedium.n2ImageWidth/2 + 'px' : feature.dmImageXL.n2ImageWidth/2 + 'px'}} src={feature.dmImageMedium ? feature.dmImageMedium.url : feature.dmImageXL.url} alt={`${feature.strTitle} in action`}/>
						<img className="studio-feature__image studio-feature__image--small" style={{maxWidth: feature.dmImageSmall ? feature.dmImageSmall.n2ImageWidth/2 + 'px' : feature.dmImageXL.n2ImageWidth/2 + 'px'}} src={feature.dmImageSmall ? feature.dmImageSmall.url : feature.dmImageXL.url} alt={`${feature.strTitle} in action`}/>
					</div>
				: null}
			</div>
		</article>
	);
}

function hexToRGB(hexColor) {
	let hex = hexColor ? hexColor : '#ffffff';

	const m = hex.match(/^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i);

	return {
			r: parseInt(m[1], 16),
			g: parseInt(m[2], 16),
			b: parseInt(m[3], 16)
	};
}